module.exports = __webpack_public_path__ + "img/_0003_图层-5.b5fca76c.png";